// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file configuracion_tarea.proto (package sextante.configuracion.tarea.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file configuracion_tarea.proto.
 */
export const file_configuracion_tarea: GenFile = /*@__PURE__*/
  fileDesc("Chljb25maWd1cmFjaW9uX3RhcmVhLnByb3RvEh9zZXh0YW50ZS5jb25maWd1cmFjaW9uLnRhcmVhLnYxIoABCglUYXJlYUl0ZW0SCgoCaWQYASABKAkSEQoJZWxpbWluYWRvGAIgASgIEhwKFHVsdGltYV9hY3R1YWxpemFjaW9uGAMgASgDEhcKCmNsaWVudGVfaWQYBCABKAlIAIgBARIOCgZub21icmUYBSABKAlCDQoLX2NsaWVudGVfaWQiUQocTGlzdFRhcmVhc0J5Q2xpZW50ZUlkUmVxdWVzdBISCgpjbGllbnRlX2lkGAEgASgJEh0KFXVsdGltYV9zaW5jcm9uaXphY2lvbhgCIAEoAyJ8Ch1MaXN0VGFyZWFzQnlDbGllbnRlSWRSZXNwb25zZRI5CgVpdGVtcxgBIAMoCzIqLnNleHRhbnRlLmNvbmZpZ3VyYWNpb24udGFyZWEudjEuVGFyZWFJdGVtEiAKGHRpbWVzdGFtcF9zaW5jcm9uaXphY2lvbhgCIAEoAyJRChNHdWFyZGFyVGFyZWFSZXF1ZXN0Eg8KAmlkGAEgASgJSACIAQESEgoKY2xpZW50ZV9pZBgCIAEoCRIOCgZub21icmUYAyABKAlCBQoDX2lkIiIKFEVsaW1pbmFyVGFyZWFSZXF1ZXN0EgoKAmlkGAEgASgJIhcKFUVsaW1pbmFyVGFyZWFSZXNwb25zZTKJAwoMVGFyZWFTZXJ2aWNlEpABCg9MaXN0QnlDbGllbnRlSWQSPS5zZXh0YW50ZS5jb25maWd1cmFjaW9uLnRhcmVhLnYxLkxpc3RUYXJlYXNCeUNsaWVudGVJZFJlcXVlc3QaPi5zZXh0YW50ZS5jb25maWd1cmFjaW9uLnRhcmVhLnYxLkxpc3RUYXJlYXNCeUNsaWVudGVJZFJlc3BvbnNlEmsKB0d1YXJkYXISNC5zZXh0YW50ZS5jb25maWd1cmFjaW9uLnRhcmVhLnYxLkd1YXJkYXJUYXJlYVJlcXVlc3QaKi5zZXh0YW50ZS5jb25maWd1cmFjaW9uLnRhcmVhLnYxLlRhcmVhSXRlbRJ5CghFbGltaW5hchI1LnNleHRhbnRlLmNvbmZpZ3VyYWNpb24udGFyZWEudjEuRWxpbWluYXJUYXJlYVJlcXVlc3QaNi5zZXh0YW50ZS5jb25maWd1cmFjaW9uLnRhcmVhLnYxLkVsaW1pbmFyVGFyZWFSZXNwb25zZUILqgIIQXBpLkdycGNiBnByb3RvMw");

/**
 * Tarea de rastro, global o propia de un cliente.
 *
 * @generated from message sextante.configuracion.tarea.v1.TareaItem
 */
export type TareaItem = Message<"sextante.configuracion.tarea.v1.TareaItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * true si el registro se dio de baja: la app lo quita de su base local.
   *
   * @generated from field: bool eliminado = 2;
   */
  eliminado: boolean;

  /**
   * Ultimo cambio del registro, en Unix ms.
   *
   * @generated from field: int64 ultima_actualizacion = 3;
   */
  ultimaActualizacion: bigint;

  /**
   * ausente = tarea global
   *
   * @generated from field: optional string cliente_id = 4;
   */
  clienteId?: string | undefined;

  /**
   * @generated from field: string nombre = 5;
   */
  nombre: string;
};

/**
 * Describes the message sextante.configuracion.tarea.v1.TareaItem.
 * Use `create(TareaItemSchema)` to create a new message.
 */
export const TareaItemSchema: GenMessage<TareaItem> = /*@__PURE__*/
  messageDesc(file_configuracion_tarea, 0);

/**
 * Pedido de las tareas de un cliente.
 *
 * @generated from message sextante.configuracion.tarea.v1.ListTareasByClienteIdRequest
 */
export type ListTareasByClienteIdRequest = Message<"sextante.configuracion.tarea.v1.ListTareasByClienteIdRequest"> & {
  /**
   * @generated from field: string cliente_id = 1;
   */
  clienteId: string;

  /**
   * Delta: ultima sincronizacion en Unix ms, el timestamp_sincronizacion de la respuesta anterior. Con 0 trae
   * todo.
   *
   * @generated from field: int64 ultima_sincronizacion = 2;
   */
  ultimaSincronizacion: bigint;
};

/**
 * Describes the message sextante.configuracion.tarea.v1.ListTareasByClienteIdRequest.
 * Use `create(ListTareasByClienteIdRequestSchema)` to create a new message.
 */
export const ListTareasByClienteIdRequestSchema: GenMessage<ListTareasByClienteIdRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_tarea, 1);

/**
 * Tareas que cambiaron desde la ultima sincronizacion.
 *
 * @generated from message sextante.configuracion.tarea.v1.ListTareasByClienteIdResponse
 */
export type ListTareasByClienteIdResponse = Message<"sextante.configuracion.tarea.v1.ListTareasByClienteIdResponse"> & {
  /**
   * @generated from field: repeated sextante.configuracion.tarea.v1.TareaItem items = 1;
   */
  items: TareaItem[];

  /**
   * Hora del servidor en Unix ms, tomada antes de consultar. La app la guarda y la manda como
   * ultima_sincronizacion en el proximo pedido.
   *
   * @generated from field: int64 timestamp_sincronizacion = 2;
   */
  timestampSincronizacion: bigint;
};

/**
 * Describes the message sextante.configuracion.tarea.v1.ListTareasByClienteIdResponse.
 * Use `create(ListTareasByClienteIdResponseSchema)` to create a new message.
 */
export const ListTareasByClienteIdResponseSchema: GenMessage<ListTareasByClienteIdResponse> = /*@__PURE__*/
  messageDesc(file_configuracion_tarea, 2);

/**
 * Datos de una tarea a crear o editar.
 *
 * @generated from message sextante.configuracion.tarea.v1.GuardarTareaRequest
 */
export type GuardarTareaRequest = Message<"sextante.configuracion.tarea.v1.GuardarTareaRequest"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string | undefined;

  /**
   * @generated from field: string cliente_id = 2;
   */
  clienteId: string;

  /**
   * @generated from field: string nombre = 3;
   */
  nombre: string;
};

/**
 * Describes the message sextante.configuracion.tarea.v1.GuardarTareaRequest.
 * Use `create(GuardarTareaRequestSchema)` to create a new message.
 */
export const GuardarTareaRequestSchema: GenMessage<GuardarTareaRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_tarea, 3);

/**
 * Tarea a eliminar.
 *
 * @generated from message sextante.configuracion.tarea.v1.EliminarTareaRequest
 */
export type EliminarTareaRequest = Message<"sextante.configuracion.tarea.v1.EliminarTareaRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message sextante.configuracion.tarea.v1.EliminarTareaRequest.
 * Use `create(EliminarTareaRequestSchema)` to create a new message.
 */
export const EliminarTareaRequestSchema: GenMessage<EliminarTareaRequest> = /*@__PURE__*/
  messageDesc(file_configuracion_tarea, 4);

/**
 * Sin datos: que el rpc no falle ya indica que se elimino.
 *
 * @generated from message sextante.configuracion.tarea.v1.EliminarTareaResponse
 */
export type EliminarTareaResponse = Message<"sextante.configuracion.tarea.v1.EliminarTareaResponse"> & {
};

/**
 * Describes the message sextante.configuracion.tarea.v1.EliminarTareaResponse.
 * Use `create(EliminarTareaResponseSchema)` to create a new message.
 */
export const EliminarTareaResponseSchema: GenMessage<EliminarTareaResponse> = /*@__PURE__*/
  messageDesc(file_configuracion_tarea, 5);

/**
 * Tareas de rastro de la SPA Cliente: catalogo de tareas que se asignan a las ejecuciones del GPS. Hay
 * tareas globales, de todos los clientes, y tareas propias de cada cliente. Logica propia del servicio
 * gRPC, sin la capa vieja de servicios. Requiere sesion de la app Cliente.
 * 
 * Pertenencia (2026-09-30): el cliente_id del pedido tiene que ser el de la sesion, y solo se tocan registros
 * de ese cliente. Otro cliente responde NotFound, igual que uno inexistente.
 *
 * @generated from service sextante.configuracion.tarea.v1.TareaService
 */
export const TareaService: GenService<{
  /**
   * Tareas globales y propias del cliente, por delta.
   *
   * @generated from rpc sextante.configuracion.tarea.v1.TareaService.ListByClienteId
   */
  listByClienteId: {
    methodKind: "unary";
    input: typeof ListTareasByClienteIdRequestSchema;
    output: typeof ListTareasByClienteIdResponseSchema;
  },
  /**
   * Crea la tarea si no viene id, o edita una propia si viene. Siempre queda como tarea propia del cliente.
   * Las tareas globales no se pueden editar (InvalidArgument). El nombre no se puede repetir entre las tareas
   * activas globales y del cliente.
   *
   * @generated from rpc sextante.configuracion.tarea.v1.TareaService.Guardar
   */
  guardar: {
    methodKind: "unary";
    input: typeof GuardarTareaRequestSchema;
    output: typeof TareaItemSchema;
  },
  /**
   * Elimina una tarea propia. Si no existe o es de otro cliente no hace nada. Una tarea global no se puede
   * eliminar (InvalidArgument).
   *
   * @generated from rpc sextante.configuracion.tarea.v1.TareaService.Eliminar
   */
  eliminar: {
    methodKind: "unary";
    input: typeof EliminarTareaRequestSchema;
    output: typeof EliminarTareaResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_configuracion_tarea, 0);

